var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "visit-calendar-schedule-update" }, [
    _c("div", { staticClass: "modal-dialog mt-0" }, [
      _c("div", { staticClass: "modal-content border-0" }, [
        _c("div", { staticClass: "modal-header px-4" }, [
          _c("h5", { staticClass: "modal-title" }, [
            _c("div", { staticClass: "d-inline mr-1" }, [
              _c("img", { staticClass: "pb-1", attrs: { src: _vm.titleIcon } })
            ]),
            _vm._v(" Tiempo ")
          ])
        ]),
        _c("div", { staticClass: "modal-body px-4" }, [
          _c("div", { staticClass: "px-2" }, [
            _c(
              "div",
              { staticClass: "mb-3" },
              [
                _c(
                  "span",
                  { staticClass: "color-gray-6 font-14 font-weight-normal" },
                  [_vm._v(" Horario de Comienzo: ")]
                ),
                _c("validation-observer", {
                  ref: "startHourForm",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("div", { staticClass: "mt-2 d-flex inputs-row" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "validation-provider",
                                  {
                                    attrs: {
                                      name: "hour",
                                      rules: `numeric|required|hour:${_vm.model.start.type}`
                                    }
                                  },
                                  [
                                    _c("custom-input", {
                                      staticClass:
                                        "calendar-available-space-input",
                                      class: {
                                        "border border-danger rounded":
                                          errors.hour?.length ||
                                          _vm.isStartGreaterThan745
                                      },
                                      attrs: { placeholder: "0" },
                                      nativeOn: {
                                        change: function($event) {
                                          return _vm.onChangeStart.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.model.start.hour,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model.start, "hour", $$v)
                                        },
                                        expression: "model.start.hour"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("div", { staticClass: "mt-1 mx-1" }, [
                              _vm._v(" : ")
                            ]),
                            _c(
                              "div",
                              { staticClass: "mr-1" },
                              [
                                _c(
                                  "validation-provider",
                                  {
                                    attrs: {
                                      name: "minute",
                                      rules: "numeric|required|quater"
                                    }
                                  },
                                  [
                                    _c("custom-input", {
                                      staticClass:
                                        "calendar-available-space-input",
                                      class: {
                                        "border border-danger rounded":
                                          errors.minute?.length ||
                                          _vm.isStartGreaterThan745
                                      },
                                      attrs: { placeholder: "00" },
                                      nativeOn: {
                                        change: function($event) {
                                          return _vm.onChangeStart.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.model.start.minute,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.start,
                                            "minute",
                                            $$v
                                          )
                                        },
                                        expression: "model.start.minute"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("div", { staticClass: "ml-1" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.model.start.type,
                                      expression: "model.start.type"
                                    }
                                  ],
                                  staticClass: "form-control px-1",
                                  class: {
                                    "border border-danger rounded":
                                      _vm.isStartGreaterThan745
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.model.start,
                                          "type",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.onChangeStart
                                    ]
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "AM" } }, [
                                    _vm._v("AM")
                                  ]),
                                  _c("option", { attrs: { value: "PM" } }, [
                                    _vm._v("PM")
                                  ])
                                ]
                              )
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "row py-0 my-0" },
                            [
                              _vm._l(errors, function(error, key) {
                                return _c(
                                  "div",
                                  {
                                    key: key,
                                    staticClass: "col-12 py-0 my-0 text-danger"
                                  },
                                  [
                                    error[0] === "Campo Requerido"
                                      ? _c("span", [
                                          _vm._v(
                                            " El campo " +
                                              _vm._s(
                                                _vm.parseErrorMessage(key)
                                              ) +
                                              " es requerido. "
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.parseErrorMessage(error[0])
                                            )
                                          )
                                        ])
                                  ]
                                )
                              }),
                              _vm.isStartGreaterThan745
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 py-0 my-0 text-danger"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " El horario seleccionado no es válido. "
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c("div", { staticClass: "mb-3" }, [
              _c(
                "span",
                { staticClass: "color-gray-6 font-14 font-weight-normal" },
                [_vm._v(" Horario de Finalización: ")]
              ),
              _c("div", { staticClass: "mt-2 d-flex inputs-row" }, [
                _c("div", [
                  _c("input", {
                    staticClass: "form-control",
                    class: {
                      "border border-danger rounded": _vm.isEndGreaterThan8
                    },
                    attrs: { disabled: "", placeholder: "0" },
                    domProps: { value: _vm.model.end.hour }
                  })
                ]),
                _c("div", { staticClass: "mt-1 mx-1" }, [_vm._v(" : ")]),
                _c("div", { staticClass: "mr-1" }, [
                  _c("input", {
                    staticClass: "form-control",
                    class: {
                      "border border-danger rounded": _vm.isEndGreaterThan8
                    },
                    attrs: { disabled: "", placeholder: "00" },
                    domProps: { value: _vm.model.end.minute }
                  })
                ]),
                _c("div", { staticClass: "ml-1" }, [
                  _c("input", {
                    staticClass: "form-control",
                    class: {
                      "border border-danger rounded": _vm.isEndGreaterThan8
                    },
                    attrs: { disabled: "" },
                    domProps: { value: _vm.model.end.type }
                  })
                ])
              ]),
              _vm.isEndGreaterThan8
                ? _c("div", { staticClass: "py-0 my-0 text-danger" }, [
                    _c("span", [
                      _vm._v(" El horario seleccionado no es válido. ")
                    ])
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "modal-footer pl-1" },
          [
            _c(
              "action-button",
              {
                attrs: {
                  id: "visit-calendar-schedule-update-cancel-btn",
                  i: "fa fa-times-circle",
                  variant: "outline-danger w-45"
                },
                on: { click: _vm.cancel }
              },
              [_vm._v(" Cancelar ")]
            ),
            _c(
              "action-button",
              {
                attrs: {
                  id: "visit-calendar-schedule-update-save-btn",
                  i: "fa fa-save",
                  variant: "success w-45"
                },
                on: { click: _vm.save }
              },
              [_vm._v(" Guardar ")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }